import * as React from "react";
import { Route, Switch } from "react-router-dom";
import List from "./Ops.RefundRequests.List";
import Detail from "./Ops.RefundRequests.Detail";

const RefundRequests = (props) => (
  <Switch>
    <Route
      exact={true}
      path="/snapscan/ops/refund_requests"
      render={() => <List {...props} />}
    />
    <Route
      exact={true}
      path="/snapscan/ops/refund_requests/:id/summary"
      render={(routerProps) => <Detail {...{ ...props, ...routerProps }} />}
    />
  </Switch>
);

export default RefundRequests;
